import { render } from "./GlobalLayout.vue?vue&type=template&id=0c23f534"
import script from "./GlobalLayout.vue?vue&type=script&lang=js"
export * from "./GlobalLayout.vue?vue&type=script&lang=js"

import "./GlobalLayout.vue?vue&type=style&index=0&id=0c23f534&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__